<template>
  <div>
    <div class="p-1">
      <b-row>
        <template v-for="(option, index) in optionsCard">
          <b-col :key="index" cols="3">
            <div
              style="position: relative"
              :key="'content-' + index"
              class="parent-card"
            >
              <b-card
                :bg-variant="isDarkSkin ? 'dark' : 'light'"
                :text-variant="isDarkSkin ? 'dark':'white'"
                :class="[classCardSelected(option.key), '']"
              >
                <div @click="changeSelectedCard(option.key)">
                  <b-card-title class="mb-0 mt-0">
                    <div class="d-flex justify-content-between">
                      <h3>{{ $t(option.title) }}</h3>
                      <tabler-icon
                        :icon="option.icon"
                        class="text-primary"
                        size="35"
                      />
                    </div>
                  </b-card-title>

                  <div
                    class="d-flex justify-content-between text-center"
                    style="margin-top: 5px"
                  >
                    <strong> {{ $t("Quantity") }}: </strong>
                    <span class="text-primary" style="font-size: 17px">{{
                      option.quantity
                    }}</span>
                  </div>
                </div>
              </b-card>
            </div>
          </b-col>
        </template>
      </b-row>
    </div>
    <!-- <div class="mb-2 d-flex justify-content-end">
      
    </div> -->
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-zones'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-zones"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="getFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="district_id"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(location)="data">
            <div v-if="cardSelected == 'zones'">
              <div v-for="(dist, index) in data.item.location" :key="index">
                {{ dist.name }}
              </div>
            </div>
            <div v-else-if="cardSelected == 'locations'">
              {{ data.item.location }}
            </div>
          </template>
          <template #cell(tolls)="data">
            <span class="text-primary"> {{ data.item.tolls }} </span>
          </template>
          <template #cell(total_amount_tolls)="data">
            <span class="text-primary"> S/ {{ data.item.total_amount_tolls }} </span>
          </template>
          <template #cell(amount)="data">
            <span class="text-primary">
              S/ {{ data.item.amount | currency }}
            </span>
          </template>
          <template #cell(created_at)="data">
            <span style="opacity: 0.7">
              {{ data.item.created_at | myGlobalDay }}
            </span>
          </template>
          <template #cell(code)="data">
            <b-badge variant="light-warning">
              {{ data.item.code }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <!-- Edit zones -->
            <feather-icon
              v-if="cardSelected == 'zones'"
              icon="EditIcon"
              size="18"
              v-b-tooltip.hover.v-warning
              :title="$t('Edit zone')"
              class="text-warning cursor-pointer"
              @click="editZone(data.item)"
            />

            <!-- Edit route -->
            <feather-icon
              v-if="cardSelected == 'routes'"
              icon="EditIcon"
              size="18"
              v-b-tooltip.hover.v-warning
              :title="$t('Edit route')"
              class="text-warning cursor-pointer"
              @click="editRoute(data.item)"
            />

            <!-- Edit rate -->
            <feather-icon
              v-if="cardSelected == 'rates'"
              icon="EditIcon"
              size="18"
              v-b-tooltip.hover.v-warning
              :title="$t('Edit rate')"
              class="text-warning cursor-pointer"
              @click="editRate(data.item)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>
    <ZonesModal
      v-if="showZonesModal == true"
      :zoneId="zoneId"
      @refreshTable="refreshTable()"
      @hideModal="hideModal"
    />

    <RoutesModal
      v-if="routeModal"
      :routeId="routeId"
      @registered="refreshTable()"
      @hideModal="routeModal = false"
    />

    <LocationsCodeModal
      v-if="showLocationCodesModal"
      @hideModal="showLocationCodesModal = false"
    />
    <RateModal
      v-if="rateModal"
      :rateId="rateId"
      @registered="refreshTable()"
      @hideModal="rateModal = false"
    />
  </div>
</template>
<script>
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/settings/views/travel-routes/data/zones.fields.js";
import TravelRouteService from "@/views/settings/views/travel-routes/services/travel-routes.service.js";
import ZonesModal from "@/views/settings/views/travel-routes/modals/ZoneModal.vue";
import RoutesModal from "@/views/settings/views/travel-routes/modals/RouteModal.vue";
import LocationsCodeModal from "@/views/settings/views/travel-routes/modals/LocationsCode.vue";
import RateModal from "@/views/settings/views/travel-routes/modals/RateModal.vue";
import ZoneFilters from "@/views/settings/views/travel-routes/data/zones.filters.js";
export default {
  components: {
    ZonesModal,
    FilterSlot,
    RoutesModal,
    LocationsCodeModal,
    RateModal,
  },
  data() {
    return {
      filters: ZoneFilters,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showZonesModal: false,
      zoneId: null,
      cardSelected: "rates",
      optionsCard: [],
      routeId: null,
      routeModal: false,
      showLocationCodesModal: false,
      rateId: null,
      rateModal: false,
      deptFilterSelected: null,
    };
  },
  async created() {
    this.generateOptionsCard();    
    await this.getRegisteredQantitiesOfCards();
  },
  computed: {
    getFields() {
      this.fields.map((f) => (f.visible = false));

      switch (this.cardSelected) {
        case "zones":
          this.fields[10].visible = true;
          this.fields[11].visible = true;
          this.fields[13].visible = true;
          this.fields[17].visible = true;
          break;
        case "routes":
          this.fields[8].visible = true;
          this.fields[9].visible = true;
          this.fields[14].visible = true;
          this.fields[15].visible = true;
          this.fields[16].visible = true;
          this.fields[17].visible = true;
          break;
        case "locations":
          this.fields[0].visible = true;
          this.fields[7].visible = true;
          this.fields[12].visible = true;
          this.fields[12].label = this.$t("District");
          this.fields[13].visible = true;
          break;
        case "rates":
          this.fields[1].visible = true;
          this.fields[2].visible = true;
          this.fields[3].visible = true;
          this.fields[4].visible = true;
          this.fields[5].visible = true;
          this.fields[6].visible = true;
          this.fields[16].visible = true;
          this.fields[17].visible = true;
        default:
          break;
      }

      return this.fields.filter((f) => f.visible == true);
    },
  },
  watch: {
    cardSelected: async function(val){
      if(val == "zones"){        
        await this.getDepartments();
      }
    }
  },
  methods: {
    generateOptionsCard() {
      this.optionsCard = [
        {
          key: "rates",
          title: "Rates",
          icon: "WalletIcon",
          quantity: 0,
        },
        {
          key: "routes",
          title: "Routes",
          icon: "RouteIcon",
          quantity: 0,
        },
        {
          key: "zones",
          title: "Zones",
          icon: "Layout2Icon",
          quantity: 0,
        },
        {
          key: "locations",
          title: "Locations",
          icon: "LocationIcon",
          quantity: 0,
        },
        // {
        //   key: "provinces",
        //   title: "Provinces",
        //   icon: "",
        // },
        // {
        //   key: "districts",
        //   title: "Districts",
        //   icon: "",
        // },
      ];
    },

    async myProvider(ctx) {
      try {
        const optionApi = this.getOptionApi();
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: 1,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: 1,
          from: this.filters[0].model,
          to: null,
          departmentId: this.filters[2].model
        };

        const { data } = await TravelRouteService[optionApi](params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },

    getOptionApi() {
      let optionApi;
      switch (this.cardSelected) {
        case "rates":
          optionApi = "getRates";
          break;
        case "routes":
          optionApi = "getTravelRoutes";
          break;
        case "zones":
          optionApi = "getZones";
          break;
        case "locations":
          optionApi = "getLocations";
          break;
        default:
          break;
      }
      return optionApi;
    },

    addZone() {
      this.zoneId = null;
      this.showZonesModal = true;
    },
    editZone(item) {
      this.zoneId = item.zone_id;
      this.showZonesModal = true;
    },
    hideModal() {
      this.showZonesModal = false;
    },
    refreshTable() {
      this.routeModal = false;
      this.showZonesModal = false;
      this.rateModal = false;
      this.$refs["ref-table-zones"].refresh();
    },

    classCardSelected(index) {
      const classes = {
        // 'cursor-pointer hover-card': !this.isModalShow,
        // 'border border-2': true,
        // 'text-white': this.cardSelected === index && this.isLightSkin,
        // 'bg-click': this.cardSelected === index,
        // 'bg-content-card':true,
        "cursor-pointer hover-card": true,
        // 'text-white':this.adsSaleIdSelected === index && this.isLightSkin,
        "bg-click": this.cardSelected === index,
      };

      return classes;
    },

    async changeSelectedCard(option) {
      try {
        this.addPreloader();
        (this.isBusy = true), (this.cardSelected = option);
        this.$emit("changeSelectedCard", this.cardSelected);
        this.$refs["ref-table-zones"].refresh();
        // await this.getCurrentClientProject();
      } catch (error) {
        this.showErrorSwal();
      } finally {
        this.isBusy = false;
        this.removePreloader();
      }
    },

    addRoute() {
      this.routeId = null;
      this.routeModal = true;
    },
    locationsCode() {
      this.showLocationCodesModal = true;
    },
    editRoute(item) {
      this.routeId = item.id;
      this.routeModal = true;
    },

    addRate() {
      this.rateId = null;
      this.rateModal = true;
    },

    editRate(item) {
      this.rateId = item.id;
      this.rateModal = true;
    },

    async getRegisteredQantitiesOfCards() {
      try {
        const { data } =
          await TravelRouteService.getRegisteredQantitiesOfCards();
        console.log("counters: ", data);
        if (data.length) {
          this.optionsCard[0].quantity = data[0].rates;
          this.optionsCard[1].quantity = data[0].routes;
          this.optionsCard[2].quantity = data[0].zones;
          this.optionsCard[3].quantity = data[0].locations;
        }
      } catch (error) {
        throw error;
      }
    },
    async getDepartments(){
      const { data } = await TravelRouteService.getDepartments();
      let options = data.map(item => ({
        "text": item.name,
        "value": item.id
      }));
      let index = this.filters.findIndex(item => item.label == 'Department');
      this.filters[index].options = options;
    },
    async getProvinces(){
      const params = {
        id: this.deptFilterSelected
      }
      const { data } = await TravelRouteService.getProvinces(params);
    }
  },
};
</script>

<style lang="scss" scoped>
%bg_pack {
  background: #6a3093; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #a044ff,
    #6a3093
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #a044ff,
    #6a3093
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.dark-layout {
  .bg-click {
    background-color: #0090e7 !important;
  }
}

.bg-click {
  .title-pack {
    color: #323030;
  }
  .icon-pack {
    color: #fff;
  }
  .status_pack {
    background: #0202022b;
  }
  .status_pack_project {
    background: #02020254;
  }
  .status_pack_project_light {
    background: #fff;
  }
  .bg-status {
    background: #00000040;
    font-weight: bold;
  }
  .bg-status-dark {
    background: #00000040;
    font-weight: bold;
  }
  color: #fff;
  @extend %bg_pack;
}
.hover-card,
.cancel {
  transition: 300ms;
}
.parent-card {
  margin-top: 3px;
  height: 115px;

  .hover-card:hover {
    @extend %bg_pack;
    color: white;
    border: none !important;
    .title-pack {
      color: #fff;
    }
    .icon-pack {
      color: #fff;
    }
    .is-view {
      display: block;
    }
  }
  .hover-card:hover {
    + .is-view {
      display: block;
    }
  }
}
</style>